import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full bg-primary-950 text-background-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 rounded-lg bg-primary-500 text-primary-50 flex items-center justify-center font-bold font-heading">
                瓜
              </span>
              <span className="text-lg font-bold font-heading">吃瓜网</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              吃瓜网是聚焦最新热点新闻、娱乐八卦与社会事件资讯的资讯平台，致力于快速、精准地传达热点内容，
              帮助用户第一时间了解明星动态、网络热议话题与生活新变化。本站内容为演示数据，仅用于产品效果展示。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="w-9 h-9 rounded-md bg-primary-900 text-background-100 flex items-center justify-center hover:bg-primary-800 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-lg"></i>
              </span>
              <span className="w-9 h-9 rounded-md bg-primary-900 text-background-100 flex items-center justify-center hover:bg-primary-800 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <span className="w-9 h-9 rounded-md bg-primary-900 text-background-100 flex items-center justify-center hover:bg-primary-800 transition-colors cursor-pointer">
                <i className="ri-qq-line text-lg"></i>
              </span>
              <span className="w-9 h-9 rounded-md bg-primary-900 text-background-100 flex items-center justify-center hover:bg-primary-800 transition-colors cursor-pointer">
                <i className="ri-mail-line text-lg"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-heading text-background-50">
              <Link to="/" className="cursor-pointer hover:text-primary-300 transition-colors">新闻分类</Link>
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {categories.map((c) => (
                <li key={c.id}>
                  <Link
                    to={`/category/${c.id}`}
                    className="text-sm text-background-300 hover:text-primary-300 transition-colors cursor-pointer"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-heading text-background-50">
              <Link to="/about" className="cursor-pointer hover:text-primary-300 transition-colors">关于本站</Link>
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-primary-300 transition-colors cursor-pointer">
                  网站定位与发展
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-primary-300 transition-colors cursor-pointer">
                  联系方式
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-primary-300 transition-colors cursor-pointer">
                  使用须知
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-primary-300 transition-colors cursor-pointer">
                  隐私政策
                </Link>
              </li>
              <li>
                <span className="text-sm text-background-300">邮箱：contact@chigua.example.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-300">© {year} 吃瓜网 chigua.example.com 版权所有（演示站点）</p>
          <p className="text-xs text-background-300">本站资讯均为演示内容，不构成任何事实陈述</p>
        </div>
      </div>
    </footer>
  );
}